var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "91px",
    viewBox: "0 0 96 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-job-3407554") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-job-3407554",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.1,20.1 L68,20.1 L68,15.3 C68,6.8 61.1,2.56088553e-16 52.7,2.56088553e-16 L43.4,2.56088553e-16 C34.9,-0.1 28,6.8 28,15.2 L28,20 L13.9,20 C6.5,20 0.5,26 0.5,33.4 L0.5,45.1 C4.9,46.4 10.9,47.8 18.9,48.9 L18.9,48.6 C18.9,44 22.6,40.3 27.2,40.3 L31.9,40.3 C36.5,40.3 40.2,44 40.2,48.6 L40.2,50.4 C42.7,50.5 45.3,50.5 48,50.5 C50.7,50.5 53.3,50.5 55.7,50.4 L55.7,48.6 C55.7,44 59.4,40.3 64,40.3 L68.7,40.3 C73.3,40.3 77,44 77,48.6 L77,49 C85,48 91,46.6 95.4,45.2 L95.4,33.5 C95.5,26 89.5,20.1 82.1,20.1 Z M39.5,20.1 L39.5,15.3 C39.5,13.2 41.2,11.5 43.3,11.5 L52.6,11.5 C54.7,11.5 56.4,13.2 56.4,15.3 L56.4,20.1 L39.5,20.1 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1,58.7 C77.1,63.3 73.4,67 68.8,67 L64.1,67 C59.5,67 55.8,63.3 55.8,58.7 L55.8,56.7 C53.3,56.8 50.7,56.8 48.1,56.8 C45.4,56.8 42.8,56.8 40.3,56.7 L40.3,58.7 C40.3,63.3 36.6,67 32,67 L27.3,67 C22.7,67 19,63.3 19,58.7 L19,55.2 C11.3,54.2 5.3,53 0.6,51.7 L0.6,76.8 C0.6,84.2 6.6,90.2 14,90.2 L82.2,90.2 C89.6,90.2 95.6,84.2 95.6,76.8 L95.6,51.6 C90.9,52.9 84.9,54.2 77.2,55.1 L77.2,58.7 L77.1,58.7 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9,60.9 C33.1,60.9 34.1,59.9 34.1,58.7 L34.1,48.7 C34.1,47.5 33.1,46.5 31.9,46.5 L27.2,46.5 C26,46.5 25,47.5 25,48.7 L25,58.7 C25,59.9 26,60.9 27.2,60.9 L31.9,60.9 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8,60.9 C70,60.9 71,59.9 71,58.7 L71,48.7 C71,47.5 70,46.5 68.8,46.5 L64.1,46.5 C62.9,46.5 61.9,47.5 61.9,48.7 L61.9,58.7 C61.9,59.9 62.9,60.9 64.1,60.9 L68.8,60.9 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.561dd6167d3267d8418714c4c7ee835e.svg";
export { ForwardRef as ReactComponent };